<template>
    <div class="th-field-error">
        <Icon icon="caution-triangle" />
        {{ error }}
    </div>
</template>

<script setup lang="ts">
import Icon from '@/components/ui/icon/Icon.vue'

defineProps<{ error: string }>()
</script>

<style lang="scss" scoped>
.th-field-error {
    font-family: $effra-font-stack;
    font-weight: 400;
    letter-spacing: 0.05em;
    padding: 5px 10px 0 3px;
    color: $red;
    font-size: 0.75rem;
    text-transform: uppercase;

    .icon {
        font-size: 0.75rem;
        font-weight: 700;
        margin: 0 7px 0 0;
    }
}
</style>
